var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var formatErrorMessage = function (error, defaultMessage) {
    if (defaultMessage === void 0) { defaultMessage = "Something went wrong. Please refresh or try again later."; }
    try {
        if (!error || error.status === 500)
            return defaultMessage;
        var response = error.response, data = error.data;
        var errorData = (response === null || response === void 0 ? void 0 : response.data) || data;
        var issue = errorData.issues && Object.values(errorData.issues)[0];
        var nestedDetail = (issue || [{}]).detail;
        return nestedDetail || issue || defaultMessage;
    }
    catch (_a) {
        return defaultMessage;
    }
};
// LocalStorage
export var saveToLocalStorage = function (key, value, serialize) {
    if (serialize === void 0) { serialize = JSON.stringify; }
    window.localStorage.setItem(key, serialize(value));
};
export var removeFromLocalStorage = function (key) {
    window.localStorage.removeItem(key);
};
export var getFromLocalStorage = function (key, defaultValue, deserialize) {
    if (deserialize === void 0) { deserialize = JSON.parse; }
    var value = window.localStorage.getItem(key);
    if (value) {
        try {
            return deserialize(value);
        }
        catch (_a) {
            window.localStorage.removeItem(key);
        }
    }
    return defaultValue;
};
export function timeout(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
var fallbackCopyTextToClipboard = function (text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        document.execCommand("copy");
        document.body.removeChild(textArea);
        return Promise.resolve("Copied to clipboard.");
    }
    catch (_a) {
        document.body.removeChild(textArea);
        return Promise.resolve("Unable to copy to clipboard.");
    }
};
export var copyTextToClipboard = function (text) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!navigator.clipboard) {
                    return [2 /*return*/, fallbackCopyTextToClipboard(text)];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, navigator.clipboard.writeText(text)];
            case 2:
                _b.sent();
                return [2 /*return*/, "Copied to clipboard."];
            case 3:
                _a = _b.sent();
                return [2 /*return*/, "Unable to copy to clipboard."];
            case 4: return [2 /*return*/];
        }
    });
}); };
